var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82799 0C5.46945 0 4.35791 1.125 4.35791 2.5V37.5C4.35791 38.875 5.46945 40 6.82799 40H31.5288C32.8873 40 33.9988 38.875 33.9988 37.5V10L24.1185 0H6.82799Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8081 10H34.0004L24.4106 0V7.5C24.4106 8.875 25.4895 10 26.8081 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 17.2727L26.1538 10H33.9999V17.2727Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6409 31.3333C29.6409 32 29.0852 32.5455 28.4059 32.5455H1.23504C0.555768 32.5455 0 32 0 31.3333V19.2121C0 18.5455 0.555768 18 1.23504 18H28.4059C29.0852 18 29.6409 18.5455 29.6409 19.2121V31.3333Z",
    fill: "#AF2F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4221 34.0912H5.23242V35.4548H28.4221C29.0934 35.4548 29.6426 34.8412 29.6426 34.0912V32.7275C29.6426 33.4775 29.0934 34.0912 28.4221 34.0912Z",
    fill: "#CAD1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85 28.81V22.19C7.85 22.09 7.93 22 8.04 22H10.39C11.62 22 12.63 23 12.63 24.21C12.63 25.45 11.62 26.46 10.4 26.46H9.15V28.81C9.15 28.91 9.06 29 8.96 29H8.04C7.93 29 7.85 28.91 7.85 28.81ZM9.15 25.24H10.35C10.91 25.24 11.34 24.79 11.34 24.2C11.34 23.65 10.91 23.23 10.35 23.23H9.15V25.24ZM13.7387 28.81V22.19C13.7387 22.09 13.8187 22 13.9287 22H16.2787C17.5087 22 18.5187 23 18.5187 24.21C18.5187 25.45 17.5087 26.46 16.2887 26.46H15.0387V28.81C15.0387 28.91 14.9487 29 14.8487 29H13.9287C13.8187 29 13.7387 28.91 13.7387 28.81ZM15.0387 25.24H16.2387C16.7987 25.24 17.2287 24.79 17.2287 24.2C17.2287 23.65 16.7987 23.23 16.2387 23.23H15.0387V25.24ZM20.7573 28.81V23.2H19.2273C19.1173 23.2 19.0373 23.11 19.0373 23.01V22.19C19.0373 22.09 19.1173 22 19.2273 22H23.5973C23.7073 22 23.7873 22.09 23.7873 22.19V23.01C23.7873 23.11 23.7073 23.2 23.5973 23.2H22.0673V28.81C22.0673 28.91 21.9773 29 21.8773 29H20.9473C20.8473 29 20.7573 28.91 20.7573 28.81Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptThumb);
export default __webpack_public_path__ + "static/media/ppt-thumb.6a82927d5351951ad3864ddcd7a2dc0d.svg";
export { ForwardRef as ReactComponent };